import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';
import { formatAriaProperties } from '@dojo/widgets/common/util';

import { Card } from '@holmescorp/card';
import { createNlsMiddleware } from '@holmescorp/lcc-state';
import { ViewProperties } from '../../interfaces';
import { Keys } from '@holmescorp/common';

// CSS
import css from '../../css/nav-card.m.css';

export interface ViewAssessmentsCardProperties extends ViewProperties {
	xqa?: string;
}

const ditabookNls = createNlsMiddleware('ditabook');
const quizNls = createNlsMiddleware('quiz');
const factory = create({
	theme,
	ditabookNls,
	quizNls
}).properties<ViewAssessmentsCardProperties>();

export const ViewAssessmentsCard = factory(({ id, properties, middleware: { theme, ditabookNls, quizNls } }) => {
	const themeCss = theme.classes(css);
	const { xqa, setTitle, switchView } = properties();
	const {
		messages: { continueAssessments = '(ditabook) continueAssessments', assess_title = '(ditabook) assess_title' }
	} = ditabookNls();
	const {
		messages: { continue: kontinue = '(quiz) continue' }
	} = quizNls();

	return v('div', { id, classes: [theme.variant()] }, [
		w(Card, { xqa }, [
			{
				content: v('div', { classes: [themeCss.assess_card, 'assess_card'] }, [
					v('div', { classes: [themeCss.title] }, [continueAssessments]),
					v('div', { classes: [themeCss.actions] }, [
						v(
							'button',
							{
								tabIndex: 0,
								onclick: (event: MouseEvent) => {
									event.stopImmediatePropagation();
									setTitle && setTitle(assess_title);
									switchView('assess');
								},
								onkeydown: (event: KeyboardEvent) => {
									switch (event.key) {
										case Keys.Enter:
										case Keys.Space:
										case Keys.Spacebar:
											event.preventDefault();
											setTitle && setTitle(assess_title);
											switchView('assess');
									}
								},
								...formatAriaProperties({ label: `${kontinue} and ${continueAssessments}` })
							},
							[kontinue]
						)
					])
				])
			}
		])
	]);
});
export default ViewAssessmentsCard;
